(ns quuppa.qsm.signin.events
  (:require [re-frame.core :as rf :refer [reg-event-fx reg-event-db]]
            [ajax.core :as ajax]
            [day8.re-frame.http-fx]
            [reitit.frontend.easy :as rfe]
            [quuppa.qsm.release-notes.events :as rn-events]))

(rf/reg-fx
  :navigate
  (fn [target]
    (cond
      (vector? target) (apply rfe/push-state target)
      (string? target) (.pushState js/history nil "" target))))

(reg-event-fx
  :user/local-login
  (fn local-login [{:keys [db]} [_ req-data]]
    {:db         (update db :session assoc :pending true)
     :http-xhrio {:method          :post
                  :uri             "/api/user/local-login"
                  :params          req-data
                  :on-success      [:user/local-login-success]
                  :on-failure      [:user/local-login-error]
                  :format          (ajax/json-request-format)
                  :response-format (ajax/json-response-format {:keywords? true})}}))

(reg-event-fx
  :user/local-login-success
  (fn [_ [_ _]]
    (js/console.info "successfully logged in!")
    (.reload js/location)
    {}))

(rf/reg-event-fx
  :user/local-login-error
  (fn [{:keys [db]} [_ _]]
    {:db (update db :session assoc :pending false)
     :fx [[:navigate "?status=unauthenticated"]]}))

(reg-event-fx
  :user/get-user
  (fn get-user [{:keys [db]} [_ opts]]
    {:db         (update db :session assoc :pending true)
     :http-xhrio {:method          :get
                  :uri             "/api/user/signin"
                  :on-failure      [:user/get-user-error]
                  :on-success      [:user/set-user opts]
                  :response-format (ajax/json-response-format {:keywords? true})}}))

(reg-event-fx
  :user/set-user
  (fn set-user [{:keys [db]} [_ opts user]]
    {:db (-> db
             (update :session assoc
                     :pending false
                     :user user)
             (assoc-in [:release-notes :available?] (boolean (:qsm-release-note-available user))))
     :fx [(when-let [e (:on-success opts)]
             [:dispatch e])
          [:dispatch [::rn-events/auto-check-on-signin]]]}))

(reg-event-fx
  :user/signout
  (fn sign-out [_ _]
    {:http-xhrio {:method          :post
                  :uri             "/api/user/signout"
                  :on-success      [:user/signout-user]
                  :on-failure      [:user/signout-user]
                  :format          (ajax/json-request-format)
                  :response-format (ajax/json-response-format {:keywords? true})}}))

(reg-event-fx
  :user/signout-user
  (fn set-user [_ _]
    ;; Just reloading the page to be safe that everything is reset.
    (.. js/document -location (reload))
    {}))

(reg-event-db
  :user/get-user-error
  (fn get-user-error [db [_ _result]]
    (update db :session assoc :pending false :user nil)))
